const avatarMap = [
  {
    id: "bobu",
    customName: "Bobu",
    integrationDate: null,
    image: "https://i.seadn.io/s/raw/files/93a24dfff5a514a785ffa6c85f0d875b.png",
  },
  {
    id: "cryptoadz",
    customName: "CrypToadz",
    integrationDate: null,
    image: "https://nftnow.com/wp-content/uploads/2021/10/cryptoadz-cr-gremplin-10252021-1200.jpg",
  },
  {
    id: "angrydynomiteswater",
    customName: "Angry Dynomites Water",
    integrationDate: null,
    image: "https://www.angrydynomiteslab.com/_next/static/media/logo.604ac926.png",
  },
  {
    id: "corntownwtf",
    customName: "Corntown",
    integrationDate: null,
    image: "https://moon.ly/uploads/nft/57421ef2-f9d9-499c-a5fa-289d27c4c326.jpg",
  },
  {
    id: "cryptocoven",
    customName: "Crypto Coven",
    integrationDate: null,
    image: "https://d22z7e9agkmda7.cloudfront.net/witch2.png",
  },
  {
    id: "anonymice",
    customName: "Anonymice",
    integrationDate: null,
    image: "https://academy.nftx.io/wp-content/uploads/2022/03/anonymice256x256.png",
  },
  {
    id: "globalbears",
    customName: "Global Bears Club",
    integrationDate: null,
    image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Avatars/globalbearsclub.jpeg",
  },
  {
    id: "blockchainbandits",
    customName: "Blockchain Bandits",
    integrationDate: null,
    image: "https://pbs.twimg.com/profile_images/1484327365232640006/SCzkcsgi_400x400.jpg",
  },
  {
    id: "galacticapes",
    customName: "Galactic Apes",
    integrationDate: null,
    image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-05-01_121719015.png",
  },
  {
    id: "deathbats",
    customName: "Deathbats",
    integrationDate: null,
    image: "https://pbs.twimg.com/profile_images/1437535140134232065/rWbEAOVB_400x400.jpg",
  },
  {
    id: "dadmfers",
    customName: "Dad MFers",
    integrationDate: null,
    image: "https://pbs.twimg.com/profile_images/1474447088012251136/wBftlwuH_400x400.jpg",
  },
  {
    id: "rugburns",
    customName: "Rugburns",
    integrationDate: null,
    image: "https://pbs.twimg.com/media/FWonEnnUcAAk0a6.jpg",
  },
  {
    id: "voxelville",
    customName: "Voxels",
    integrationDate: null,
    image: "https://Pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-02-10_201544005.png",
  },
  {
    id: "gamingapeclub",
    customName: "Gaming Ape Club",
    integrationDate: null,
    image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-02-11_020318275.png",
  },
  {
    id: "chibidinos",
    customName: "Chibi Dinos",
    integrationDate: null,
    image: "https://cryptodailycdn.ams3.digitaloceanspaces.com/nfts-analytics/assets/chibidinos-2.png",
  },
  {
    id: "angrydynomitesfire",
    customName: "Angry Dynomites Fire",
    integrationDate: null,
    image: "https://www.angrydynomiteslab.com/_next/static/media/logo.604ac926.png",
  },
  {
    id: "squishiverse",
    customName: "Squishiverse",
    integrationDate: null,
    image: "https://i.seadn.io/s/raw/files/87cc6a152eb4f3e4b329ede867a7266a.png",
  },
  {
    id: "kia",
    customName: "Koala Intelligence Agency",
    integrationDate: null,
    image: "https://stockhead.com.au/wp-content/uploads/2021/08/Screenshot-2021-08-16-at-14.43.22.png",
  },
  {
    id: "dizzy",
    customName: "Dizzy Dragons",
    integrationDate: null,
    image: "https://dizzydragons.s3.amazonaws.com/1000/1.0.0/13.png",
  },
  {
    id: "mfers",
    customName: "MFers",
    integrationDate: null,
    image: "https://moon.ly/uploads/nft/clfibyh8m0399ptjsacpgo4tq.png",
  },
  {
    id: "galacticapes-v2",
    customName: "Galactic Apes",
    integrationDate: null,
    image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-05-01_121719015.png",
  },
  {
    id: "zoogang",
    customName: "Zoo Gang",
    integrationDate: null,
    image: "https://Pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-02-10_202422392.png",
  },
  {
    id: "dininho",
    customName: "Dininho",
    integrationDate: null,
    image: "https://Pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-02-10_202647985.png",
  },
  {
    id: "daoduckgenesis",
    customName: "Dao Duck",
    integrationDate: null,
    image: "https://Pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-02-10_202834827.png",
  },
  {
    id: "llamaverse",
    customName: "Llamaverse",
    integrationDate: null,
    image: "https://i.seadn.io/gcs/files/f1708e84eedc487a1296f536759575c0.png",
  },
  {
    id: "cybersnails",
    customName: "Cyber Snails",
    integrationDate: null,
    image: "https://Pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-02-10_203121197.png",
  },
  {
    id: "foxyfam",
    customName: "Foxy Fam",
    integrationDate: null,
    image: "https://cryptodailycdn.ams3.digitaloceanspaces.com/nfts-analytics/assets/foxyfamnft-3.png",
  },
  {
    id: "timelesscharacters",
    customName: "Timeless Characters",
    integrationDate: null,
    image: "https://s3.amazonaws.com/cdn.nftpricefloor/projects/v1/timeless-characters.png",
  },
  {
    id: "barnowlz",
    customName: "Barn Owlz",
    integrationDate: null,
    image:
      "https://dappradar.com/image-resizer/width=168,quality=100/https://cdn.simplehash.com/assets/ae790172f36d057cf2bce2fce7e0d7ebd4376dc0d34569b751e6eac436876037.jpg",
  },
  {
    id: "robotfeelings",
    customName: "Robot Feelings",
    integrationDate: null,
    image: "https://robotfeelings.io/static/media/robot_6.0f4892764b1e6a77646d.png",
  },
  {
    id: "pixelcatclub",
    customName: "Pixel Cat Club",
    integrationDate: null,
    image: "https://Pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-02-10_203450217.png",
  },
  {
    id: "subwayrats",
    customName: "Subway Rats",
    integrationDate: null,
    image: "https://pbs.twimg.com/profile_images/1494473705895858178/E-vkG8UA_400x400.jpg",
  },
  {
    id: "phunks",
    customName: "Phunks",
    integrationDate: null,
    image: "https://Pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-02-10_203626501.png",
  },
  {
    id: "pixelscholarz",
    customName: "Scholarz",
    integrationDate: null,
    image: "https://Pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-02-10_203741625.png",
  },
  {
    id: "pixeldoges",
    customName: "Pixel Doges",
    integrationDate: null,
    image: "https://pbs.twimg.com/profile_images/1480007485092249606/dPJUgzpI_400x400.jpg",
  },
  {
    id: "farmhands",
    customName: "Farmhands",
    integrationDate: null,
    image: "https://Pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-02-10_203852777.png",
  },
  {
    id: "saltysharks",
    customName: "Salty Sharks",
    integrationDate: null,
    image: "https://pbs.twimg.com/profile_images/1694954282918068225/PdX8A2rX_400x400.jpg",
  },
  {
    id: "thebibiz",
    customName: "The Bibiz",
    integrationDate: null,
    image: "https://Pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-02-10_203958263.png",
  },
  {
    id: "glizzygang",
    customName: "Glizzy Gang",
    integrationDate: null,
    image:
      "https://dappradar.com/image-resizer/width=168,quality=100/https://cdn.simplehash.com/assets/12b66b87c65858f84668f565f40e11ec56f7c07adba0d3644115fa6f108c50ba.png",
  },
  {
    id: "lunartics",
    customName: "Lunartics",
    integrationDate: null,
    image: "https://pbs.twimg.com/media/GjC9xOTW0AATGqY.jpg",
  },
  {
    id: "cryptomasks",
    customName: "Cryptomasks",
    integrationDate: null,
    image: "https://pbs.twimg.com/media/Ge7JM9QXcAAyfL6.jpg",
  },
  {
    id: "chadsclub",
    customName: "Chads Club",
    integrationDate: null,
    image: "https://Pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-02-10_204213518.png",
  },
  {
    id: "cryptozombiez",
    customName: "Crypto Zombiez",
    integrationDate: null,
    image: "https://coin-images.coingecko.com/nft_contracts/images/193/large/-GnUxUz1_400x400.png",
  },
  {
    id: "cryptocannabisclub",
    customName: "Crypto Cannabis Club",
    integrationDate: null,
    image: "https://Pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-02-10_204325997.png",
  },
  {
    id: "dapperdinos",
    customName: "Dapper Dinos",
    integrationDate: null,
    image: "https://assets.bitdegree.org/crypto-tracker/dapp-logos/ethereum/dapper-dinos-logo.png",
  },
  {
    id: "cryptoPunks",
    customName: "Crypto Punks",
    integrationDate: null,
    image: "https://img.decrypt.co/insecure/rs:fit:3840:0:0:0/plain/https://cdn.decrypt.co/wp-content/uploads/2022/02/cryptopunks-5822-record-sale-gID_7.png",
  },
  {
    id: "gendun",
    customName: "Generative Dungeons",
    integrationDate: null,
    image: "https://Pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-02-10_204548458.png",
  },
  {
    id: "foxfam",
    customName: "Foxfam",
    integrationDate: null,
    image: "https://assets.bitdegree.org/crypto-tracker/dapp-logos/ethereum/foxfam-logo.png",
  },
  {
    id: "boredapeyachtclub",
    customName: "BAYC",
    integrationDate: null,
    image: "https://img.decrypt.co/insecure/rs:fit:3840:0:0:0/plain/https://cdn.decrypt.co/wp-content/uploads/2021/12/adidas-bored-ape-ethereum-nft2-gID_4.png",
  },
  {
    id: "grillzgang",
    customName: "Grillz Gang",
    integrationDate: null,
    image: "https://pbs.twimg.com/media/Giv5OUWWkAA0k4Q.jpg",
  },
  {
    id: "cryptomories",
    customName: "Cryptomories",
    integrationDate: null,
    image: "https://s3.amazonaws.com/cdn.nftpricefloor/projects/v1/cryptomories.png",
  },
  {
    id: "daoducks",
    customName: "Daoducks",
    integrationDate: null,
    image: "https://Pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-02-10_202834827.png",
  },
  {
    id: "spectralskellies",
    customName: "Spectral Skellies",
    integrationDate: null,
    image: "https://pbs.twimg.com/profile_images/1445435250851651586/2N92x2iV_400x400.jpg",
  },
  {
    id: "larvalads",
    customName: "Larva Lads",
    integrationDate: null,
    image: "https://pbs.twimg.com/media/GjRiAcDWoAAoKnC.jpg",
  },
  {
    id: "averagepunks",
    customName: "Average Punks",
    integrationDate: null,
    image: "https://nftcalendar.io/storage/uploads/2022/02/04/unnamed__3__0204202203512761fca2bfe68b4.png",
  },
  {
    id: "pudgypenguins",
    customName: "Pudgy Penguins",
    integrationDate: null,
    image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Avatars/pudgypenguins.png",
  },
  {
    id: "gridcraft",
    customName: "Gridcraft",
    integrationDate: null,
    image: "https://Pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-02-10_205550011.png",
  },
  {
    id: "zooverse",
    customName: "Zooverse",
    integrationDate: null,
    image: "https://pbs.twimg.com/profile_images/1569759374687744000/zW2Fvr5w_400x400.jpg",
  },
  {
    id: "dystoapez",
    customName: "Dystoapez",
    integrationDate: null,
    image: "https://Pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-02-10_205702203.png",
  },
  {
    id: "labgrownbeasts",
    customName: "Lab Grown Beasts",
    integrationDate: null,
    image: "https://Pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-02-10_205812573.png",
  },
  {
    id: "chibiapes",
    customName: "Chibi Apes",
    integrationDate: null,
    image: "https://coin-images.coingecko.com/nft_contracts/images/176/large/nAdDM2QZ_400x400.jpg",
  },
  {
    id: "chainrunners",
    customName: "Chainrunners",
    integrationDate: null,
    image: "https://pbs.twimg.com/profile_images/1617679208070926341/HaAhVA5p_400x400.jpg",
  },
  {
    id: "pixelBeasts",
    customName: "Pixel Beasts",
    integrationDate: null,
    image: "https://nftcalendar.io/storage/uploads/2021/09/_0241_09242021212203614e417b81197.png",
  },
  {
    id: "zenapes",
    customName: "Zenapes",
    integrationDate: null,
    image: "https://Pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-02-10_210258070.png",
  },
  {
    id: "kittyinu",
    customName: "KittyInu",
    integrationDate: null,
    image: "https://coin-images.coingecko.com/coins/images/19385/large/KITTY.png",
  },
  {
    id: "mocaverse",
    customName: "Mocaverse",
    integrationDate: null,
    image: "https://static.wixstatic.com/media/0de4af_439b71187b72472bb92bebd0a9c38dfa~mv2.jpg",
  },
  {
    id: "augmintedlabsscientists",
    customName: "Augminted Lab Scientists",
    integrationDate: null,
    image: "https://Pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-02-10_210558902.png",
  },
  {
    id: "kaijukingz",
    customName: "Kaiju Kingz",
    integrationDate: null,
    image: "https://pbs.twimg.com/media/F6Ud38dbMAAeTnj.jpg",
  },
  {
    id: "littlelemonfriends",
    customName: "Little Lemon Friends",
    integrationDate: null,
    image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Avatars/littlelemonfriends.png",
  },
  {
    id: "tribeodyssey",
    customName: "Tribe Odyssey",
    integrationDate: null,
    image: "https://Pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-02-10_210749494.png",
  },
  {
    id: "tribesters",
    customName: "Tribesters",
    integrationDate: null,
    image: "https://tk-storage.s3.ap-southeast-1.amazonaws.com/host/game/WpRWJ49r_400x400_20230918190441.jpg",
  },
  {
    id: "playember",
    customName: "Play Ember",
    integrationDate: null,
    image: "https://Pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-02-10_211104782.png",
  },
  {
    id: "ethlizardventure",
    customName: "ETH Lizard Adventure",
    integrationDate: null,
    image: "https://s3.amazonaws.com/cdn.nftpricefloor/projects/v1/ethlizards.png",
  },
  {
    id: "nyancatballoon",
    customName: "Nyan Cat Balloon",
    integrationDate: null,
    image: "https://Pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-02-10_211700082.png",
  },
  {
    id: "ethlizardlocked",
    customName: "ETH Lizard Locked",
    integrationDate: null,
    image: "https://Pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-02-10_213301409.png",
  },
  {
    id: "chimperstraining",
    customName: "Chimpers Training",
    integrationDate: null,
    image: "https://Pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-02-10_221204085.png",
  },
  {
    id: "habibiz",
    customName: "The Habibiz",
    integrationDate: null,
    image: "https://s2.coinmarketcap.com/static/img/coins/200x200/26733.png",
  },
  {
    id: "fishballerz",
    customName: "Fishballerz",
    integrationDate: null,
    image: "https://pbs.twimg.com/ext_tw_video_thumb/1846620454280146944/pu/img/Ho8G5JW_KiOYXIAc.jpg",
  },
  {
    id: "kongz",
    customName: "Cyberkongz ETH",
    integrationDate: null,
    image: "https://pbs.twimg.com/media/FxpzhnWWAAETctI.jpg",
  },
  {
    id: "jihoz",
    customName: "Jihoz",
    integrationDate: null,
    image: "https://Pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-02-10_214835887.png",
  },
  {
    id: "pixelchickens",
    customName: "Pixel Chickens",
    integrationDate: null,
    image: "https://Pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-02-10_215154136.png",
  },
  {
    id: "kongzvxeth",
    customName: "Cyberkongz VX ETH",
    integrationDate: null,
    image: "https://coin-images.coingecko.com/nft_contracts/images/90/large/cyberkongz.gif",
  },
  {
    id: "chimpers",
    customName: "Chimpers",
    integrationDate: null,
    image: "https://Pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-02-10_213953307.png",
  },
  {
    id: "moonbirds",
    customName: "Moonbirds",
    integrationDate: null,
    image: "https://d34jlxpwrja7q9.cloudfront.net/wp-content/uploads/2022/04/moonbirds.png",
  },
  {
    id: "marscatsvoyage",
    customName: "Mars Cat Voyage",
    integrationDate: null,
    image: "https://marscatsvoyage.com/uploads/tmp/kq/h4/kqH44XhFPx.png",
  },
  {
    id: "theplague",
    customName: "The Plague",
    integrationDate: null,
    image: "https://s3.amazonaws.com/cdn.nftpricefloor/projects/v1/the-plague-nft.png",
  },
  {
    id: "falarmonkey",
    customName: "Kaidro Journal",
    integrationDate: null,
    image: "https://Pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-02-10_224011504.png",
  },
  {
    id: "pixelchibis",
    customName: "Pixel Chibis",
    integrationDate: null,
    image: "https://pbs.twimg.com/profile_images/1767127753147441153/I_ywT9jo_400x400.jpg",
  },
  {
    id: "dollsidekick",
    customName: "Doll Sidekick",
    integrationDate: null,
    image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Avatars/dollsidekick.gif",
  },
  {
    id: "kongzronin",
    customName: "Cyberkongz Genkai Ronin",
    integrationDate: null,
    image: "https://pbs.twimg.com/media/FxpzhnWWAAETctI.jpg",
  },
  {
    id: "kongzvxronin",
    customName: "Cyberkongz VX Ronin",
    integrationDate: null,
    image: "https://coin-images.coingecko.com/nft_contracts/images/90/large/cyberkongz.gif",
  },
  {
    id: "peacefulgroupied",
    customName: "Peaceful Groupies",
    integrationDate: null,
    image: "https://assets.bitdegree.org/crypto-tracker/dapp-logos/ethereum/peaceful-groupies-v2-logo.png",
  },
  {
    id: "rugburns-v2",
    customName: "Rugburns V2",
    integrationDate: null,
    image: "https://pbs.twimg.com/media/FWonEnnUcAAk0a6.jpg",
  },
  {
    id: "mastercat",
    customName: "Mastercat",
    integrationDate: null,
    image: "https://pbs.twimg.com/media/GOSpJ3CXAAAP6jJ.jpg",
  },
  {
    id: "lazyLions",
    customName: "Lazy Lions",
    integrationDate: null,
    image: "https://coin-images.coingecko.com/nft_contracts/images/124/large/LION.png",
  },
  {
    id: "chimpersgenesis",
    customName: "Chimpers Genesis",
    integrationDate: null,
    image: "https://Pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-02-10_230744315.png",
  },
  {
    id: "cryptobeasts",
    customName: "Cryptobeasts",
    integrationDate: null,
    image: "https://Pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-02-10_232523997.png",
  },
  {
    id: "partyapebillionaires",
    customName: "Party Ape Billionaires",
    integrationDate: null,
    image: "https://Pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-02-10_232830161.png",
  },
  {
    id: "dreamlandgenesis",
    customName: "Dreamland Genesis",
    integrationDate: null,
    image:
      "https://dappradar.com/image-resizer/width=168,quality=100/https://cdn.simplehash.com/assets/01968bb0395ad7ee00829f3ce093dea9d562883a65bdbbdadb9cecacaa899919.png",
  },
  {
    id: "pixelporks",
    customName: "Pixel Porks",
    integrationDate: null,
    image: "https://lootrush-website-assets.s3.us-east-1.amazonaws.com/images/games/pixel-porks040135/Card.png",
  },
  {
    id: "onchainmonkey",
    customName: "On-Chain Monkey",
    integrationDate: null,
    image: "https://miro.medium.com/v2/resize:fit:1400/1*2gGZdwkoltQlvURXg9tIhA.png",
  },
  {
    id: "secretsocietyofwhales",
    customName: "SSOW",
    integrationDate: null,
    image: "https://cryptodailycdn.ams3.digitaloceanspaces.com/nfts-analytics/assets/secretsocietyofwhales-1.png",
  },
  {
    id: "deadfellaz",
    customName: "Deadfellaz",
    integrationDate: null,
    image: "https://coincentral.com/wp-content/uploads/2022/01/deadfellaz.png",
  },
  {
    id: "sparksuits",
    customName: "Kaidro Spark Suits",
    integrationDate: null,
    image: "https://cdn.skymavis.com/ronin/2020/erc721/0x56d4e6ce96f850bdc1dfd086ac1c19a1e2d5b5c5/logo.png",
  },
  {
    id: "spiritofmimo",
    customName: "Spirit of Mimo",
    integrationDate: null,
    image: "https://pbs.twimg.com/profile_images/1768797752698314752/uFuGnSFC_400x400.jpg",
  },
  {
    id: "triballytikis",
    customName: "Tribally",
    integrationDate: null,
    image: "https://Pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-02-10_233849790.png",
  },
  {
    id: "pyjamasclub",
    customName: "Pyjamas Club",
    integrationDate: null,
    image: "https://lootrush-website-assets.s3.us-east-1.amazonaws.com/images/games/pyjamas-clubs---pixels886308/Card.png",
  },
  {
    id: "xtreme",
    customName: "Xtreme",
    integrationDate: null,
    image: "https://i.seadn.io/gcs/files/8174680c0a55b93c40e329c4ec047479.png",
  },
  {
    id: "freedomninjas",
    customName: "Freedom Ninjas",
    integrationDate: null,
    image: "https://pbs.twimg.com/profile_images/1731643696083337216/iVpZdMjQ_400x400.jpg",
  },
  {
    id: "gam3s",
    customName: "Gam3rs",
    integrationDate: null,
    image: "https://Pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-02-10_234044689.png",
  },
  {
    id: "nyancat",
    customName: "Nyan cat",
    integrationDate: null,
    image: "https://Pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-02-10_234146191.png",
  },
  {
    id: "ethlizardgenesis",
    customName: "ETH Lizard Genesis",
    integrationDate: null,
    image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-02-10_234425412.png",
  },
  {
    id: "tribestersnexus",
    customName: "Tribesters Nexus",
    integrationDate: null,
    image: "https://tk-storage.s3.ap-southeast-1.amazonaws.com/host/game/WpRWJ49r_400x400_20230918190441.jpg",
  },
  {
    id: "grainglitchers",
    customName: "Grain Glitchers - ETH",
    integrationDate: null,
    image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-02-11_000134525.png",
  },
  {
    id: "doonz",
    customName: "Doonz",
    integrationDate: null,
    image: "https://pbs.twimg.com/media/Gda0zylXoAA_jMs.jpg",
  },
  {
    id: "kaijufrenz",
    customName: "Kaiju Frenz",
    integrationDate: null,
    image: "https://pbs.twimg.com/media/FOmrYmCacAMrS_z.jpg",
  },
  {
    id: "pixelprimates",
    customName: "Pixel Primates",
    integrationDate: null,
    image: "https://pbs.twimg.com/profile_images/1431445557256626183/r48HRddq_400x400.jpg",
  },
  {
    id: "mocaversehonourarymocas",
    customName: "Mocaverse",
    integrationDate: null,
    image: "https://static.wixstatic.com/media/0de4af_439b71187b72472bb92bebd0a9c38dfa~mv2.jpg",
  },
  {
    id: "pixelcorgis",
    customName: "Pixel Corgis",
    integrationDate: null,
    image: "https://pbs.twimg.com/profile_images/1777096387018260480/AI8h1huJ_400x400.jpg",
  },
  {
    id: "pixelcatclubnextgen",
    customName: null,
    integrationDate: null,
    image: "https://pbs.twimg.com/media/Gi5EZ02XQAAOqVk.jpg",
  },
  {
    id: "fightleague",
    customName: "Fight League",
    integrationDate: null,
    image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-02-11_000522885.png",
  },
  {
    id: "arteezzykool",
    customName: "Art Eezzy Kool",
    integrationDate: null,
    image: "https://pbs.twimg.com/profile_images/1843096725470486528/l-N2GJNV_400x400.jpg",
  },
  {
    id: "moondoonz",
    customName: "Moon Doonz",
    integrationDate: null,
    image: "https://pbs.twimg.com/media/GLiel9XWIAAVTzq.jpg",
  },
  {
    id: "dizzydemons",
    customName: "Dizzy Demons",
    integrationDate: null,
    image: "https://pbs.twimg.com/profile_images/1477725190519988226/sFDbQjqt_400x400.jpg",
  },
  {
    id: "machinearena",
    customName: "The Machines Arena",
    integrationDate: null,
    image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-02-11_015038139.png",
  },
  {
    id: "pixelmon",
    customName: "Kevin / Pixelmon",
    integrationDate: null,
    image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-02-11_015649593.png",
  },
  {
    id: "pixelmontrainers",
    customName: "Kevin / Pixelmon",
    integrationDate: null,
    image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-02-11_015649593.png",
  },
  {
    id: "chickverse",
    customName: "Chickverse",
    integrationDate: null,
    image: "https://pbs.twimg.com/profile_images/1829491421860212736/veA48cU6_400x400.jpg",
  },
  {
    id: "thelittles",
    customName: "The Littles",
    integrationDate: null,
    image: "https://pbs.twimg.com/profile_images/1552711544781172736/9YEYvJcr_400x400.jpg",
  },
  {
    id: "moki",
    customName: "Moki Genesis",
    integrationDate: null,
    image: "https://cdn.skymavis.com/mavis-mkp/launchpad-data/moki-genesis/thumbnail-5.jpg",
  },
  {
    id: "cryptokitty",
    customName: "Cryptokitties",
    integrationDate: null,
    image: "https://img.cryptokitties.co/0x06012c8cf97bead5deae237070f9587f8e7a266d/896775.shadow.png",
  },
  {
    id: "ghostmania",
    customName: "Ghostmania",
    integrationDate: null,
    image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-02-11_015852101.png",
  },
  {
    id: "pilots",
    customName: "Kaidro Pilots",
    integrationDate: null,
    image: "https://cdn.skymavis.com/mavis-mkp/game-data/pilots-edition-01/image-1.jpg",
  },
  {
    id: "althea",
    customName: "Legends of Althea",
    integrationDate: null,
    image: "https://lootrush-website-assets.s3.us-east-1.amazonaws.com/images/games/legends-of-althea097142/Card.png",
  },
  {
    id: "justabominables",
    customName: "Just Abominables",
    integrationDate: null,
    image: "https://pbs.twimg.com/media/F93QpGfawAAKJ1R.jpg",
  },
  {
    id: "piggies",
    customName: "Piggies",
    integrationDate: null,
    image: "https://i.seadn.io/s/raw/files/96ecb1b0ce9d818b52d9346314823a4e.png",
  },
  {
    id: "mysticat",
    customName: "Mysticats",
    integrationDate: null,
    image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-02-11_020546801.png",
  },
  {
    id: "grainglitchersronin",
    customName: "Grain Glitchers Ronin",
    integrationDate: null,
    image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-02-11_000134525.png",
  },
  {
    id: "mysticalpaca",
    customName: "Mystical Alpaca",
    integrationDate: null,
    image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-02-17_153332081.png",
  },
  {
    id: "grimhead",
    customName: "The Grimhead Project",
    integrationDate: null,
    image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-02-23_024927741.png",
  },
  {
    id: "roninchibis",
    customName: "Ronin Chibis",
    integrationDate: null,
    image: "https://pbs.twimg.com/profile_images/1767127753147441153/I_ywT9jo_400x400.jpg",
  },
  {
    id: "ronke",
    customName: "Ronke",
    integrationDate: null,
    image: "https://cdn.skymavis.com/mavis-mkp/launchpad-data/ronke/avatar-3.jpg",
  },
  {
    id: "pixelpuppies",
    customName: "Pixel Puppies",
    integrationDate: "Feb 26 2025",
    image: "https://f003.backblazeb2.com/file/Pixelore/Avatars/image_2025-03-11_170533634.png",
  },
  {
    id: "fortuneronin",
    customName: "Fortune Ronin",
    integrationDate: "Mar 5 2025",
    image: "https://pbs.twimg.com/media/Gj1NEb3aAAArmt5.jpg",
  },
  {
    id: "tsoep",
    customName: "Sovereigns of Elite Pact",
    integrationDate: "March 31 2025",
    image: "https://cdn.roninchain.com/ronin/2020/erc721/0xdea00a9663e4ff6151cc9c970fb522e9695d2769/logo.png",
  },
  {
    id: "pawtectors",
    customName: "Pawtectors",
    integrationDate: "April 17 2025",
    image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-05-01_122128546.png",
  },
  {
    id: "frwc",
    customName: "Forgotten Runes Wizards Cult",
    integrationDate: "May 5th, 2025",
    image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Avatars/Dotta800.gif",
  },
  {
    id: "pixeldragons",
    customName: "Pixel Dragons",
    integrationDate: "May 14th, 2025",
    image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Avatars/pixeldragons.png",
  },
  {
    id: "thehorde",
    customName: "The Horde",
    integrationDate: "May 22nd, 2025",
    image: "https://cdn.skymavis.com/mavis-mkp/launchpad-data/the-horde/content-3-1.gif",
  },
  {
    id: "pixolotl",
    customName: "Pixolotl",
    integrationDate: "July 4, 2025",
    image: "https://pbs.twimg.com/profile_images/1938556061029642240/RLL9sADg_400x400.jpg",
  },{
    id: "blvck",
    customName: "Blvck",
    integrationDate: "July 7, 2025",
    image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-07-16_132809397.png",
  },{
    id: "primos",
    customName: "Primos Warriors",
    integrationDate: "July 9, 2025",
    image: "https://pbs.twimg.com/profile_images/1883911555768602627/sdkEku08_400x400.jpg",
  },{
    id: "pixelpuppiesreborn",
    customName: "Pixel Puppies Reborn",
    integrationDate: "July 15, 2025",
    image: "https://pbs.twimg.com/profile_images/1873294781931253760/FXIiEWcM_400x400.jpg",
  },{
    id: "pygmyhippos",
    customName: "Pygmy Hippos",
    integrationDate: "July 15, 2025",
    image: "https://pbs.twimg.com/profile_images/1842014103839408128/B5FhMTtJ_400x400.png",
  },{
    id: "roninchibisft",
    customName: "Ronin Chibis Forgotten Tribe",
    integrationDate: "July 21, 2025",
    image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-07-21_185827427.png",
  },{
    id: "gnomes",
    customName: "Gnome Creatures",
    integrationDate: "July 23, 2025",
    image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-07-23_114305738.png",
  },{
    id: "pixelkittens",
    customName: "Pixel Kittens",
    integrationDate: "Oct 1, 2025",
    image: "https://pixelore.s3.eu-central-003.backblazeb2.com/Avatars/image_2025-10-09_171751215.png",
  },
];

module.exports = { avatarMap };
